import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { bindActionCreators } from 'redux';
// import classNames from 'classnames';
// import Products from './components/Products';

import { Button, FormControlLabel, MenuItem, Radio, Typography, Checkbox, Toolbar, AppBar } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import TextField from 'material-ui/TextField';
import Formsy from 'formsy-react';
import classNames from 'classnames';
import $ from "jquery";
import { withAlert } from 'react-alert';
// import PropTypes from 'prop-types';
import FileUpload from '@material-ui/icons/FileUpload';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import AddIcon from '@material-ui/icons/Add';
import ReactDOM from 'react-dom';
import Select from 'react-select';

import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import Loader from "other-components/loader/loader";

import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    layoutRoot: {},
    // layoutToolbar: {
    //     padding: 0
    // },
    // tabsRoot: {
    //     height: 64
    // },
    // tabRoot: {
    //     height: 64
    // },
    // root: {
    //     width: '100%',
    // },
    // heading: {
    //     fontSize: theme.typography.pxToRem(15),
    //     flexBasis: '33.33%',
    //     flexShrink: 0,
    // },
    // secondaryHeading: {
    //     fontSize: theme.typography.pxToRem(15),
    //     color: theme.palette.text.secondary,
    // }
});


var id = null;
var acc_type = null;
var update_id = null;
var idLedAcc = null;
var bank = null;
var bank_route_no = null;
var branch_name = null;
var branch_code = null;
var address1 = null;
var address2 = null;
var country = null;
var state = null;
var city = null;
var zip_code = null;
var email = null;
var telephone = null;
var fax = null;
var acc_holder_name = null;
var joint_acc_holder_name = null;
var acc_no = null;
var description = null;
var is_active = null;

class Broker extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            banks: [],
            openComposeDialog: false,
            openComposeEditDialog: false,
            loading: true,
            isActive: true,
            isActiveEdit: false,
            isTableAdd: false,
            brokerObj: null,
            bank: '',
            bankTypeEdit: '',
            accountTypeValue: '',
            accountTypeEditValue: '',
            shown: false,
            bankName: '',
            acc_type: '',
            acc_type_edit: '',
            value: ''
        };
        // alert(this.props.ref_no)
        this.loadData();
        this.loadBanks();
        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
        this.openEditBankDialog = this.openEditBankDialog.bind(this);
        this.closeEditBankDialog = this.closeEditBankDialog.bind(this);
    }

    openNewCustomerDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        // this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        this.setState({ openComposeDialog: false });
    }

    openEditBankDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeEditDialog: true });
        // this.setState({ loading: false });
    }

    closeEditBankDialog() {
        this.setState({ openComposeEditDialog: false });
    }

    onChangedAccountType = (e) => {

        this.setState({
            acc_type: e.target.value
        });

        if (e.target.value == "Joint") {
            this.setState({
                shown: true
            });
        } else {
            this.setState({
                shown: false
            });
        }

    }

    onChangedAccountTypeEdit = (e) => {

        this.setState({
            acc_type_edit: e.target.value
        });

        if (e.target.value == "Joint") {
            this.setState({
                shown: true
            });
        } else {
            this.setState({
                shown: false
            });
        }

    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };



    clearValue = () => {
        this.form.reset();
        this.setState({
            accountType: '',
            acc_type: '',
            bank: ''
        });
    }

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };



    onEdit = (model) => {
        this.editBankDetails(model);
    };

    // edit employee profesional qulification details
    editBankDetails(model) {
        var bank;
        if (this.state.bankTypeEdit.value == null) {
            bank = this.state.bankTypeEdit;
        } else {
            bank = this.state.bankTypeEdit.value;
        }

        const bankObj = {
            id: model.id,
            bank: bank,
            idLedAcc: model.idLedAcc,
            acc_type: this.state.acc_type_edit,
            bank_route_no: model.bank_routine_no,
            branch_name: model.branch_name,
            branch_code: model.branch_code,
            address1: model.bank_address1,
            address2: model.bank_address2,
            country: model.country,
            state: model.state,
            city: model.city,
            zip_code: model.zip_code,
            email: model.email,
            telephone: model.telephone,
            fax: model.fax,
            acc_holder_name: model.acc_holder_name,
            joint_acc_holder_name: model.joint_acc_holder_name,
            acc_no: model.acc_number,
            description: model.description,
            is_active: this.state.isActiveEdit
        }

        // console.log(accountCategoryObj)
        // axios.post('http://localhost:5009/bank/updateBankDetails', bankObj)
        axios.post(window.accountServer + '/bank/updateBankDetails', bankObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");

                    if ("EXIST" == res.data.message) {
                        this.props.alert.error("Cannot update ! Already this account has transactions");
                    } else {
                        this.props.alert.success("Account Category Details Updated Successfully.");
                        this.closeEditBankDialog();
                        this.loadData();
                    }

                } else {
                    // alert('Ivalid Credentials');
                    this.props.alert.error("Error In Account Category Update.");
                }

            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

    }


    handleBank = (selectedOption) => {
        this.setState({
            bank: selectedOption
        });

    }
    handleBankEdit = (selectedOption) => {
        this.setState({
            bankTypeEdit: selectedOption
        });

    }

    handleAcountTypeEdit = (selectedOption) => {
        this.setState({
            accountTypeEdit: selectedOption.value,
            accountTypeEditValue: selectedOption
        });

    }

    handleCheckSuspendChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckSuspendChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };


    // load employee gender into drop-down
    loadBanks() {
        var banks = [];
        // axios.get('http://localhost:5009/accountType/getAccountTypes')
        axios.get(window.systemServer + '/system/loadBanks')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.result[i].bank_name));
                        banks.push({
                            value: response.data.result[i].bank_name,
                            label: response.data.result[i].bank_name
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data[i].bank_name));
                        banks.push({
                            value: response.data[i].bank_name,
                            label: response.data[i].bank_name
                        });
                    }
                this.setState({ banks: banks });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadData() {
        var resObj;
        // axios.get('http://localhost:5009/bank/getAllBankDetails')
        axios.get(window.accountServer + '/bank/getAllBankDetails')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.bankDetails;
                    this.appendToTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.closeNewCustomerDialog();
    }


    appendToTable(bankObj) {

        console.log(bankObj)
        var data = [];
        var active;
        if (bankObj.length == 0) {
            this.setState({ data: data });
            this.setState({ loading: false });
        } else {
            for (var i = 0; i < bankObj.length; i++) {
                if (bankObj[i].IS_ACTIVE == 1) {
                    active = 'Active'
                } else {
                    active = 'Inactive'

                }
                data.push({
                    update_id: bankObj[i].ID_BANK_ACCOUNT,
                    id: "B-" + bankObj[i].ID_BANK_ACCOUNT,
                    idLedAcc: bankObj[i].ID_LEDGER_ACCOUNT,
                    acc_type: bankObj[i].ACCOUNT_TYPE,
                    bank: bankObj[i].BANK_NAME,
                    bank_route_no: bankObj[i].ROUTING_NO,
                    branch_name: bankObj[i].BRANCH,
                    branch_code: bankObj[i].BRANCH_CODE,
                    address1: bankObj[i].BANK_ADDRESS1,
                    address2: bankObj[i].BANK_ADDRESS2,
                    country: bankObj[i].COUNTRY,
                    state: bankObj[i].STATE,
                    city: bankObj[i].CITY,
                    zip_code: bankObj[i].ZIP_CODE,
                    email: bankObj[i].EMAIL,
                    telephone: bankObj[i].TELEPHONE,
                    fax: bankObj[i].FAX,
                    acc_holder_name: bankObj[i].ACCOUNT_HOLDER_NAME,
                    joint_acc_holder_name: bankObj[i].JOINT_ACCOUNT_HOLDER_NAME,
                    acc_no: bankObj[i].ACCOUNT_NO,
                    description: bankObj[i].DESCRIPTION,
                    is_active: bankObj[i].IS_ACTIVE,
                    active: active
                });

            }

            this.setState({ data: data });
            this.setState({ loading: false });
        }

    }



    onSubmit = (model) => {

        if ("" == this.state.acc_type || null == this.state.acc_type || undefined == this.state.acc_type) {
            this.props.alert.error("Select Account Type");
        } else {
            this.saveAccountCategory(model);
        }

    };

    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }



    saveAccountCategory(model) {
        const ledgerAccountObj = {
            account_type_id: 1,
            accountType: "ASSET",
            accountCategory: 1,
            main_account_id: 4,
            ledger_name: model.acc_number,
            accountCategoryName: "CURRENT ASSETS ",
            // mainAccRef: this.state.mainAccRef.value,
            // mainAccName: this.state.mainAccName.label,
            mainAccRef: "101004",
            mainAccName: "BANK MAIN ACCOUNT",
            ledger_code: null,
            ledger_refNo: "101004",
            description: model.description,
            is_active: this.state.isActive
        }

        // bankInfoLedgerCode = model.ledger_code;
        console.log(ledgerAccountObj)

        // axios.post('http://localhost:5009/ledgerAccount/createLedgerAccount', ledgerAccountObj)
        axios.post(window.accountServer + '/ledgerAccount/createLedgerAccount', ledgerAccountObj)
            .then(res => {

                if (res.data.success) {



                    const accountCategoryObj = {
                        bank: this.state.bank.value,
                        acc_type: this.state.acc_type,
                        bank_route_no: model.bank_routine_no,
                        branch_name: model.branch_name,
                        branch_code: model.branch_code,
                        address1: model.bank_address1,
                        address2: model.bank_address2,
                        country: model.country,
                        state: model.state,
                        city: model.city,
                        zip_code: model.zip_code,
                        email: model.email,
                        telephone: model.telephone,
                        fax: model.fax,
                        ledger_id: res.data.insertId,
                        acc_holder_name: model.acc_holder_name,
                        joint_acc_holder_name: model.joint_acc_holder_name,
                        acc_no: model.acc_number,
                        description: model.description,
                        is_active: this.state.isActive
                    }

                    console.log(accountCategoryObj)


                    // axios.post('http://localhost:5009/bank/createBankDetails', accountCategoryObj)
                    axios.post(window.accountServer + '/bank/createBankDetails', accountCategoryObj)
                        .then(res => {

                            if (res.data.success) {
                                // alert("Success");
                                this.props.alert.success("Bank Details added Successfully.");
                                this.loadData();
                                this.form.reset();
                                this.setState({
                                    bank: '',
                                    acc_type: ''
                                });

                            } else {
                                // alert(res.data.message);
                                this.props.alert.error(res.data.message);
                            }
                        })


                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })









    }


    // createBankAccountLedger(acc_no, description) {

    // }

    render() {

        const { classes, setSearchText, searchText } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <React.Fragment>
                    <div>
                        <Toolbar className="flex w-full pt-24 px-12 ml-1920">
                            <h2 className="w-full subtitle-color">
                                Bank View
                            </h2>
                            <div className="px-12">
                                <Button
                                    className="w-160"
                                    type="button"
                                    variant="raised"
                                    color="secondary"
                                    onClick={(ev) => {
                                        this.openNewCustomerDialog();
                                    }}
                                >
                                    New Bank
                                </Button>
                            </div>
                            <div className="px-12">
                                <Button
                                    variant="raised"
                                    color="default"
                                >
                                    Help
                                </Button>
                            </div>
                        </Toolbar>

                        <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md">
                            <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                <Toolbar className="flex w-full">
                                    <Typography className="w-full" variant="subheading" color="inherit">
                                        Bank Information
                                    </Typography>
                                    <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>

                            <Formsy
                                onValidSubmit={this.onSubmit}
                                onValid={this.enableButton}
                                onInvalid={this.disableButton}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center"
                            >

                                <div className="w-full p-16 mt-8 pr-24 bank-popup-margin " >
                                    <div >
                                        <h3 className="mt-4">Account Category</h3>
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/5 mt-48 ">
                                        Bank Name
                                        <Select
                                            className="w-full mt-16"
                                            name="form-field-name"
                                            placeholder="Select Bank"
                                            value={this.state.bank}
                                            onChange={this.handleBank}
                                            options={this.state.banks}
                                        />
                                    </div>
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24 mt-8"
                                        type="text"
                                        name="bank_routine_no"
                                        label="Bank Routine No"
                                        required
                                        validations={{
                                            maxLength: 50
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}

                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24"
                                        type="text"
                                        name="branch_name"
                                        label="Branch Name"
                                        required
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />


                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24"
                                        type="text"
                                        name="branch_code"
                                        label="Branch Code"
                                        validations={{
                                            maxLength: 250
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/2 pr-24"
                                        type="text"
                                        name="bank_address1"
                                        label="Bank Address Line 1"

                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />


                                    <TextFieldFormsy
                                        className="w-full md:w-1/2 pr-24"
                                        type="text"
                                        name="bank_address2"
                                        label="Bank Address Line 2"
                                        validations={{
                                            maxLength: 250
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />

                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 pr-24 mt-8"
                                        type="text"
                                        name="country"
                                        label="Country"

                                        validations={{
                                            maxLength: 50
                                        }}
                                        validationErrors={{
                                            maxLength: 'This is not a valid'
                                        }}

                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 pr-24"
                                        type="text"
                                        name="state"
                                        label="State"

                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{
                                            maxLength: 'This is not a valid'
                                        }}
                                    />


                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 pr-24"
                                        type="text"
                                        name="city"
                                        label="City"
                                        validations={{
                                            maxLength: 250
                                        }}
                                        validationErrors={{
                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 pr-24"
                                        type="text"
                                        name="zip_code"
                                        label="Zip Code"
                                        validations={{
                                            maxLength: 250
                                        }}
                                        validationErrors={{
                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24 mt-8"
                                        type="email"
                                        name="email"
                                        label="Email"
                                        validations="isEmail"
                                        validationError="This is not a valid email"

                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24"
                                        type="number"
                                        name="telephone"
                                        label="Telephone"
                                        required
                                        validations={{
                                            maxLength: 20
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />


                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24"
                                        type="number"
                                        name="fax"
                                        label="Fax"
                                        validations={{
                                            maxLength: 20
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/2 pr-24 "
                                        type="text"
                                        name="acc_holder_name"
                                        label="Account Holder's Name"
                                        required
                                        validations={{
                                            maxLength: 200
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                    <label className="md:w-1/3 ml-24 text-lg mt-32">
                                        <input onChange={this.onChangedAccountType} className="w-16 h-16 mt-32" type="radio" name="searchType" value="Saving" checked={this.state.acc_type === 'Saving'} />Saving</label>
                                    <label className="md:w-1/3 ml-24 text-lg">
                                        <input onChange={this.onChangedAccountType} className="w-16 h-16 mt-32" type="radio" name="searchType" value="Current" checked={this.state.acc_type === 'Current'} />Current</label>
                                    <label className="md:w-1/3 ml-24 text-lg">
                                        <input onChange={this.onChangedAccountType} className="w-16 h-16 mt-32" type="radio" name="searchType" value="Joint" checked={this.state.acc_type === 'Joint'} />Joint</label>

                                    {
                                        this.state.shown
                                            ? < TextFieldFormsy
                                                className="w-full md:w-1/2 pr-24 mb-16"
                                                type="text"
                                                name="joint_acc_holder_name"
                                                label="Joint Account Holder's Name"
                                                required
                                                validations={{
                                                    maxLength: 200
                                                }}
                                                validationErrors={{

                                                    maxLength: 'This is not a valid'
                                                }}
                                            />
                                            : null

                                    }

                                    <div></div>
                                    <TextFieldFormsy
                                        className="w-full md:w-1/2 pr-24"
                                        type="text"
                                        name="acc_number"
                                        label="Account Number"
                                        required
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />


                                    <TextFieldFormsy
                                        className="w-full md:w-1/2 pr-24"
                                        type="text"
                                        name="description"
                                        label="Description"
                                        validations={{
                                            maxLength: 250
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                    <div className="w-full md:w-1/4 pr-24">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.isActive}
                                                    onChange={this.handleCheckActiveChange('isActive')}
                                                    color="primary"
                                                    disabled
                                                // checked
                                                />
                                            }
                                            label="Active"
                                        />
                                    </div>
                                    <div className="w-full md:w-2/3">

                                    </div>

                                    <div className="w-full md:w-1/3 float-right mb-16">

                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                            Save
                                        </Button>

                                        <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ml-8 mr-8 " onClick={this.clearValue}>
                                            Clear
                                        </Button>
                                        <Button type="button" variant="raised" color="primary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ml-8 mr-8" onClick={this.closeNewCustomerDialog}>
                                            Close
                                        </Button>
                                    </div>
                                </div>
                            </Formsy>

                        </Dialog>

                        <div className="p-20">
                            <div>
                                <div className="flex flex-wrap -mx-3 mb-12">
                                    <div className="w-full md:w-2/3"></div>
                                    {/* <div className="w-full md:w-1/3">
                                
                                <TextField
                                    placeholder="Search for anything"
                                    className="pl-16"
                                    fullWidth
                                    value={this.state.value}
                                    inputProps={{
                                        'aria-label': 'Search'
                                    }}
                                    onChange={this.handleSearchAny}
                                />
                                {/* <Icon className="-mb-4 -mr-4" color="action">search</Icon> */}
                                    {/* </div> */}
                                </div>


                                <div class="flex h-auto mt-4">

                                    <div class="w-full bg-white h-auto">
                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {

                                                    }
                                                }
                                            }}
                                            data={this.state.data}
                                            columns={[
                                                {
                                                    Header: "Bank Code",
                                                    accessor: "id",
                                                    className: "justify-start",
                                                    maxWidth: 300,


                                                },
                                                {
                                                    Header: "idLedAcc",
                                                    accessor: "idLedAcc",
                                                    className: "justify-start",
                                                    maxWidth: 300,
                                                    show: false
                                                },
                                                {
                                                    Header: "Bank Name",
                                                    accessor: "bank",
                                                    className: "justify-start",
                                                    maxWidth: 300,

                                                },
                                                {
                                                    Header: "Account Type",
                                                    accessor: "acc_type",
                                                    className: "justify-start",
                                                    maxWidth: 300,

                                                },
                                                {
                                                    Header: "Account Number",
                                                    accessor: "acc_no",
                                                    className: "justify-start",
                                                    maxWidth: 300,

                                                },
                                                {
                                                    Header: "Status",
                                                    accessor: "status",
                                                    className: "justify-center",
                                                    maxWidth: 200,
                                                    Cell: row => (

                                                        <div className="flex items-center">
                                                            <Icon
                                                                className={row.original.active === 'Active' ? 'text-green-light'
                                                                    : row.original.active === 'Inactive' ? 'text-red-light'
                                                                        : 'text-orange-light'}
                                                                title={row.original.active === 'Active' ? 'Active'
                                                                    : row.original.active === 'Inactive' ? 'Inactive'
                                                                        : 'text-orange-light'}
                                                            >
                                                                {row.original.active === 'Active' ? 'check_circle'
                                                                    : row.original.active === 'Inactive' ? `cancel`
                                                                        : 'Other'}
                                                            </Icon>

                                                        </div>
                                                    )

                                                },
                                                {
                                                    Header: "Action",
                                                    className: "justify-center",
                                                    maxWidth: 100,
                                                    // accessor: "su",
                                                    width: 128,
                                                    Cell: row => (
                                                        <div className="flex items-center w-8 h-8">
                                                            <IconButton

                                                                onClick={(e) => {
                                                                    if (row) {
                                                                        id = row.original.id;
                                                                        acc_type = row.original.acc_type;
                                                                        update_id = row.original.update_id;
                                                                        bank = row.original.bank;
                                                                        idLedAcc = row.original.idLedAcc;
                                                                        bank_route_no = row.original.bank_route_no;
                                                                        branch_name = row.original.branch_name;
                                                                        branch_code = row.original.branch_code;
                                                                        address1 = row.original.address1;
                                                                        address2 = row.original.address2;
                                                                        country = row.original.country;
                                                                        state = row.original.state;
                                                                        city = row.original.city;
                                                                        zip_code = row.original.zip_code;
                                                                        email = row.original.email;
                                                                        telephone = row.original.telephone;
                                                                        fax = row.original.fax;
                                                                        acc_holder_name = row.original.acc_holder_name;
                                                                        joint_acc_holder_name = row.original.joint_acc_holder_name;
                                                                        acc_no = row.original.acc_no;
                                                                        description = row.original.description;
                                                                        // alert(bank_route_no)

                                                                        this.setState({
                                                                            acc_type_edit: row.original.acc_type
                                                                        });

                                                                        if (row.original.acc_type == "Joint") {
                                                                            this.setState({
                                                                                shown: true
                                                                            });
                                                                        } else {
                                                                            this.setState({
                                                                                shown: false
                                                                            });
                                                                        }
                                                                        // var banks = [];
                                                                        // banks.push({
                                                                        //     value: row.original.bank,
                                                                        //     label: row.original.bank
                                                                        // });

                                                                        this.setState({
                                                                            bankTypeEdit: row.original.bank

                                                                        });
                                                                        this.setState({ isActiveEdit: row.original.is_active });

                                                                        this.openEditBankDialog();
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-blue" title="Edit">mode_edit</Icon>
                                                            </IconButton>

                                                            <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeEditDialog} fullWidth maxWidth="md">
                                                                <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                                                    <Toolbar className="flex w-full">
                                                                        <Typography className="w-full" variant="subheading" color="inherit">
                                                                            Edit Bank Information
                                                                        </Typography>
                                                                        <IconButton className="" color="inherit" onClick={this.closeEditBankDialog} aria-label="Close">
                                                                            <CloseIcon />
                                                                        </IconButton>
                                                                    </Toolbar>
                                                                </AppBar>

                                                                <Formsy
                                                                    onValidSubmit={this.onEdit}
                                                                    onValid={this.enableButton}
                                                                    onInvalid={this.disableButton}
                                                                    ref={(form) => this.form = form}
                                                                    className="flex flex-col justify-center"
                                                                >

                                                                    <div className="w-full p-16 mt-8 pr-24 " >
                                                                        {/* <div >
                                                                            <h3 className="mt-4">Account Category</h3>
                                                                        </div> */}

                                                                        <div className="w-full sm:w-1/2 md:w-1/5 mt-48 ">
                                                                            Bank Name
                                                                            <Select
                                                                                className="w-full mt-16"
                                                                                name="form-field-name"
                                                                                placeholder="Select Bank"
                                                                                value={this.state.bankTypeEdit}
                                                                                onChange={this.handleBankEdit}
                                                                                options={this.state.banks}
                                                                            />
                                                                        </div>
                                                                        <TextFieldFormsy
                                                                            type="hidden"
                                                                            name="id"
                                                                            value={update_id}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            type="hidden"
                                                                            name="idLedAcc"
                                                                            value={idLedAcc}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/3 pr-24 mt-8"
                                                                            type="text"
                                                                            name="bank_routine_no"
                                                                            label="Bank Routine No"
                                                                            value={bank_route_no}
                                                                            required
                                                                            validations={{
                                                                                maxLength: 50
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}

                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/3 pr-24"
                                                                            type="text"
                                                                            name="branch_name"
                                                                            label="Branch Name"
                                                                            required
                                                                            value={branch_name}
                                                                            validations={{
                                                                                maxLength: 150
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />


                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/3 pr-24"
                                                                            type="text"
                                                                            name="branch_code"
                                                                            label="Branch Code"
                                                                            value={branch_code}
                                                                            validations={{
                                                                                maxLength: 250
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/2 pr-24"
                                                                            type="text"
                                                                            name="bank_address1"
                                                                            label="Bank Address Line 1"
                                                                            value={address1}
                                                                            validations={{
                                                                                maxLength: 150
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />


                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/2 pr-24"
                                                                            type="text"
                                                                            name="bank_address2"
                                                                            label="Bank Address Line 2"
                                                                            value={address2}
                                                                            validations={{
                                                                                maxLength: 250
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/4 pr-24 mt-8"
                                                                            type="text"
                                                                            name="country"
                                                                            label="Country"
                                                                            value={country}
                                                                            validations={{
                                                                                maxLength: 50
                                                                            }}
                                                                            validationErrors={{
                                                                                maxLength: 'This is not a valid'
                                                                            }}

                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/4 pr-24"
                                                                            type="text"
                                                                            name="state"
                                                                            label="State"
                                                                            value={state}
                                                                            validations={{
                                                                                maxLength: 150
                                                                            }}
                                                                            validationErrors={{
                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />


                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/4 pr-24"
                                                                            type="text"
                                                                            name="city"
                                                                            label="City"
                                                                            value={city}
                                                                            validations={{
                                                                                maxLength: 250
                                                                            }}
                                                                            validationErrors={{
                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/4 pr-24"
                                                                            type="text"
                                                                            name="zip_code"
                                                                            label="Zip Code"
                                                                            value={zip_code}
                                                                            validations={{
                                                                                maxLength: 250
                                                                            }}
                                                                            validationErrors={{
                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/3 pr-24 mt-8"
                                                                            type="email"
                                                                            name="email"
                                                                            label="Email"
                                                                            value={email}
                                                                            validations="isEmail"
                                                                            validationError="This is not a valid email"

                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/3 pr-24"
                                                                            type="number"
                                                                            name="telephone"
                                                                            label="Telephone"
                                                                            value={telephone}
                                                                            required
                                                                            validations={{
                                                                                maxLength: 20
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />


                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/3 pr-24"
                                                                            type="number"
                                                                            name="fax"
                                                                            label="Fax"
                                                                            value={fax}
                                                                            validations={{
                                                                                maxLength: 20
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/2 pr-24 "
                                                                            type="text"
                                                                            name="acc_holder_name"
                                                                            label="Account Holder's Name"
                                                                            value={acc_holder_name}
                                                                            validations={{
                                                                                maxLength: 200
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />
                                                                        <label className="md:w-1/3 ml-24 text-lg mt-32">
                                                                            <input onChange={this.onChangedAccountTypeEdit} className="w-16 h-16 mt-32" type="radio" name="searchType" value="Saving" checked={this.state.acc_type_edit === 'Saving'} />Saving</label>
                                                                        <label className="md:w-1/3 ml-24 text-lg">
                                                                            <input onChange={this.onChangedAccountTypeEdit} className="w-16 h-16 mt-32" type="radio" name="searchType" value="Current" checked={this.state.acc_type_edit === 'Current'} />Current</label>
                                                                        <label className="md:w-1/3 ml-24 text-lg">
                                                                            <input onChange={this.onChangedAccountTypeEdit} className="w-16 h-16 mt-32" type="radio" name="searchType" value="Joint" checked={this.state.acc_type_edit === 'Joint'} />Joint</label>

                                                                        {
                                                                            this.state.shown
                                                                                ? < TextFieldFormsy
                                                                                    className="w-full md:w-1/2 pr-24 mb-16"
                                                                                    type="text"
                                                                                    name="joint_acc_holder_name"
                                                                                    label="Joint Account Holder's Name"
                                                                                    value={joint_acc_holder_name}
                                                                                    validations={{
                                                                                        maxLength: 200
                                                                                    }}
                                                                                    validationErrors={{

                                                                                        maxLength: 'This is not a valid'
                                                                                    }}
                                                                                />
                                                                                : null

                                                                        }

                                                                        <div></div>
                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/2 pr-24"
                                                                            type="text"
                                                                            name="acc_number"
                                                                            label="Account Number"
                                                                            value={acc_no}
                                                                            validations={{
                                                                                maxLength: 150
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />


                                                                        <TextFieldFormsy
                                                                            className="w-full md:w-1/2 pr-24"
                                                                            type="text"
                                                                            name="description"
                                                                            label="Description"
                                                                            value={description}
                                                                            validations={{
                                                                                maxLength: 250
                                                                            }}
                                                                            validationErrors={{

                                                                                maxLength: 'This is not a valid'
                                                                            }}
                                                                        />
                                                                        <div className="w-full md:w-1/4 pr-24">
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.isActiveEdit}
                                                                                        onChange={this.handleCheckActiveChange('isActiveEdit')}
                                                                                        color="primary"
                                                                                    // disabled
                                                                                    // checked
                                                                                    />
                                                                                }
                                                                                label="Active"
                                                                            />
                                                                        </div>
                                                                        <div className="w-full md:w-2/3">

                                                                        </div>

                                                                        <div className="w-full md:w-1/3 float-right mb-16">

                                                                            <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                                                                Update
                                                                            </Button>

                                                                            <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ml-8 mr-8 " onClick={this.clearValue}>
                                                                                Clear
                                                                            </Button>
                                                                            <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ml-8 mr-8" onClick={this.closeEditBankDialog}>
                                                                                Close
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </Formsy>

                                                            </Dialog>

                                                        </div>
                                                    )
                                                }

                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(Broker));


// WEBPACK FOOTER //
// ./src/main/content/accounting/bank/Bank.js